module.exports = __webpack_public_path__ + "static/media/status.dff6f9d1.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/status.svg
// module id = 1145
// module chunks = 0